import type { ReactNode } from "react";

export const extractTextFromReactNode = (
  node: ReactNode,
): string | undefined => {
  if (typeof node === "string") {
    return node;
  }
  if (typeof node === "number") {
    return String(node);
  }
  if (Array.isArray(node)) {
    return node.map(extractTextFromReactNode).filter(Boolean).join(" ");
  }
  return undefined;
};
